import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutQuoteCustomerLookup extends Layout {
    sourceQuoteCustomer: DataSource;
    tableCustomer: Table;
}
